import { useCallback, useEffect, useState } from 'react'
import priorityService from '../services/priorityService'
import { getPriorityMeta } from '../utils/priorityMatrix'

/**
 * Catálogo de prioridades (`Tickets.priority`) con un helper para mostrar su
 * nombre. Si el catálogo no carga se usan las etiquetas de `PRIORITY_META`.
 *
 * @returns {{ priorities: Array<Object>, priorityLabel: (id: number) => string }}
 */
export default function useTicketPriorities() {
  const [priorities, setPriorities] = useState([])

  useEffect(() => {
    let active = true
    priorityService.getAll().then(({ success, data }) => {
      if (active && success) setPriorities(data)
    })
    return () => {
      active = false
    }
  }, [])

  const priorityLabel = useCallback(
    (id) =>
      priorities.find((p) => p.id === Number(id))?.name ||
      getPriorityMeta(id).label,
    [priorities]
  )

  return { priorities, priorityLabel }
}
